<template>
    <span>
        <a href="#" @click.prevent="toggle()">
            <span class="Navbar__dropdown-name">{{ name }}</span>
        </a>
        <ul class="Navbar__dropdown-menu" v-show="show">
            <li>
                <logout-form></logout-form>
            </li>
        </ul>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
            }
        },

        props: ['name', 'items'],

        mounted() {
            bus.$on('overlay-clicked', function () {
                this.show = false;
            }.bind(this));
        },

        methods: {
            /**
             * Toggle whether the dropdown is displayed
             */
            toggle() {
                bus.$emit('show-overlay');

                this.show = ! this.show;
            },
        },
    }
</script>